import { render, staticRenderFns } from "./PreDischarge.vue?vue&type=template&id=57e37c3d&"
import script from "./PreDischarge.vue?vue&type=script&lang=js&"
export * from "./PreDischarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports